import { render, staticRenderFns } from "./FeeStructure.vue?vue&type=template&id=083e15ce&scoped=true&"
import script from "./FeeStructure.vue?vue&type=script&lang=js&"
export * from "./FeeStructure.vue?vue&type=script&lang=js&"
import style0 from "./FeeStructure.vue?vue&type=style&index=0&id=083e15ce&lang=scss&scoped=true&"
import style1 from "./FeeStructure.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./FeeStructure.vue?vue&type=style&index=2&id=083e15ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083e15ce",
  null
  
)

export default component.exports